import * as ResourceApi from 'api/resources';

// search bar will be disabled in routes matching these patterns
export const DisabledPathRegexps = Object.freeze([
  /\/hub\/*/,
  /\/rewards\/*/
]);

export const RenderedElsewhere = Object.freeze([
  ResourceApi.Types.PrizeEntry,
  ResourceApi.Types.Winner
]);

export const FiltersByResourceType = Object.freeze({
  [ResourceApi.Types.Break]: [{field: 'platform', value: 'MASTER'}],
  [ResourceApi.Types.Winner]: [{field: 'winner', value: true}]
});

export const PluralResourceTypes = Object.freeze({
  [ResourceApi.Types.PrizeEntry]: 'prize entries'
});

export const normalizeResource = resource => ({
  ...resource,
  key: resource.id
});

export const normalizeBreak = resource => ({
  ...resource,
  key: resource.id,
  id: resource.challengeId,
  description: resource.permalink || resource.challengeId
});

export const normalizeImage = resource => ({
  ...resource,
  key: resource.id,
  title: resource.name || resource.id,
  description: resource.name || resource.id
});

const ResourcePathMappings = {
  '/images': ResourceApi.Types.Image,
  '/breaks': ResourceApi.Types.Break,
  '/break/.*': ResourceApi.Types.Break,

  '/prizes/.*': ResourceApi.Types.Prize,
  '/winners/.*': ResourceApi.Types.Winner,

  '/prize/.*/edit': ResourceApi.Types.Prize,
  '/prize/.*/entries': ResourceApi.Types.PrizeEntry,
  '/prize/.*/winners': ResourceApi.Types.Winner
};

export const mapPathnameToResourceType = pathname => {
  const match = Object.keys(ResourcePathMappings).find(pattern => new RegExp(pattern).test(pathname));

  // if no match, assume '/'.
  const resourceType = match ? ResourcePathMappings[match] : ResourceApi.Types.Break;
  return resourceType;
};



// WEBPACK FOOTER //
// ./public/components/MasterSearchBar/utils.js